import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditColorIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M16 12.4312C16 14.4386 15.1571 16.3637 13.6569 17.7832C12.1566 19.2026 10.1217 20 8 20C5.87827 20 3.84344 19.2026 2.34315 17.7832C0.842854 16.3637 0 14.4386 0 12.4312C0 7.76211 6.11793 1.61065 7.65393 0.137259C7.69815 0.0938502 7.75117 0.0593222 7.80982 0.0357387C7.86846 0.0121551 7.93153 0 7.99526 0C8.05898 0 8.12206 0.0121551 8.1807 0.0357387C8.23935 0.0593222 8.29237 0.0938502 8.33659 0.137259C9.85363 1.6712 16 8.10972 16 12.4312Z" 
        fill={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EditColorIcon;